/**
 * @description Component-TradePairInfoMobile
 */
import { ExternalLink } from '@/components/Link';
import './index.less';

import TokenSymbol from '@/components/TokenLogo/TokenSymbol';
import UnderlineToolTip from '@/components/ToolTip/UnderlineToolTip';
import { WrappedPair } from '@/entities/WrappedPair';
import { usePairInfo } from '@/features/pair/hook';
import { useEtherscanLink } from '@/hooks/web3/useChain';
import { shortenAddress } from '@/utils/address';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IPropTypes {
  currentPair?: WrappedPair;
}

const TradePairInfoMobile: FC<IPropTypes> = ({ currentPair }) => {
  //   const chainId = useChainId();
  const { t } = useTranslation();
  //   const currentPairBaseInfo = useCurrentPairBaseInfoFromUrl(chainId);
  //   const marketPairInfo = useMarketPairInfo(chainId, currentPairBaseInfo?.instrumentAddr, currentPairBaseInfo?.expiry);
  const pairInfo = usePairInfo(currentPair);
  const getEtherscanLink = useEtherscanLink();

  if (!pairInfo) return null;
  return (
    <div className="syn-trade-chart-pair-info-mobile">
      <div className="syn-trade-chart-pair-info-mobile-header">
        <TokenSymbol logoSize={24} tokenInfo={pairInfo?.displayBaseToken} />
      </div>
      <div className="syn-trade-chart-pair-info-mobile-container">
        <div className="syn-trade-chart-pair-info-mobile-title">{t('common.pairInfo')}</div>
        <div className="syn-trade-chart-pair-info-mobile-items">
          <dl>
            <dt>{t('common.tradePage.base')}</dt>
            <dd>{pairInfo.displayBaseToken.symbol}</dd>
          </dl>
          <dl>
            <dt>{t('common.tradePage.quote')}</dt>
            <dd>{pairInfo.displayQuoteToken.symbol}</dd>
          </dl>
          <dl>
            <dt>{t('common.tradePage.maturity')}</dt>
            <dd>{pairInfo.expiry}</dd>
          </dl>
          <dl>
            <dt>{t('common.tradePage.margin')}</dt>
            <dd>{pairInfo.marginToken.symbol}</dd>
          </dl>{' '}
          <dl>
            <dt>{t('common.tradePage.imrShort')}</dt>
            <dd>{pairInfo.imrRate.formatPercentage({ colorShader: false })}</dd>
          </dl>
          <dl>
            <dt>{t('common.tradePage.mmrShort')}</dt>
            <dd>{pairInfo.mmrRate.formatPercentage({ colorShader: false })}</dd>
          </dl>{' '}
          <dl>
            <dt>{t('common.tradePage.tfr')}</dt>
            <dd>{pairInfo.tradingFeeRatio.add(pairInfo.protocolFeeRatio).formatPercentage({ colorShader: false })}</dd>
          </dl>
          <dl>
            <dt>{t('common.tradePage.lofr')}</dt>
            <dd>{pairInfo.tradingFeeRatio.formatPercentage({ colorShader: false })}</dd>
          </dl>{' '}
          <dl>
            <dt>{t('common.tradePage.mTs')}</dt>
            <dd>
              {pairInfo.minQuoteTradeSize.formatNumberWithTooltip({
                isShowTBMK: true,
                suffix: pairInfo.marginToken.symbol,
              })}
            </dd>
          </dl>
          <dl>
            <dt>
              <UnderlineToolTip title={t('common.tradePage.tipTooltip')}>{t('common.tradePage.tip')}</UnderlineToolTip>
            </dt>
            <dd>{pairInfo.tip.formatNumberWithTooltip({ isShowTBMK: true, suffix: pairInfo.marginToken.symbol })}</dd>
          </dl>{' '}
          <dl>
            <dt>{t('common.tradePage.oracle')}</dt>
            <dd>{pairInfo?.oracleInfo?.name}</dd>
          </dl>
          <dl>
            <dt>{t('common.tradePage.marginAdd')}</dt>
            <dd>
              <ExternalLink href={getEtherscanLink(pairInfo.marginToken.address, 'address')}>
                {shortenAddress(pairInfo.marginToken.address)}
              </ExternalLink>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default TradePairInfoMobile;
